import Vue from 'vue'
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './scss/index.scss';
import './components/ResourceList';
import './components/PartnerResources';
import './components/renamePage';
import KyligenceUI from 'kyligence-ui'
Vue.use(KyligenceUI)




// WEBPACK FOOTER //
// ./App/index.js